import React, { Component } from "react";
import { useEffect, useState } from "react";

import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";
import { min } from "react-sparklines";
import moment from "moment";

const LineGraphTotal = props => {
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  const [series, setSeries] = useState([
    {
      name: "MAX",
      data: [5, 5, 5, 5, 5, 5, 5],
    },
    {
      name: "TSO",
      data: [-6, -4, 2.1, 1, -3, 2.2, 4],
    },
    {
      name: "PTT",
      data: [5, 4, -2.5, 3.5, -2, 4.2, 7.66],
    },
    {
      name: "EGAT",
      data: [0, 0, 0, 0, 0, 0, 0],
    },
    {
      name: "MIN",
      data: [-5, -5, -5, -5, -5, -5, -5],
    },
  ]);
  const [options, setOptions] = useState({
    chart: { zoom: { enabled: !1 }, toolbar: { show: !1 } },
    colors: ["#FE5555", "#FF7F37", "#62C6FF", "#FFF577", "#FE5555"],
    dataLabels: { enabled: !1 },
    stroke: {
      width: [3, 3, 3, 3, 3],
      curve: "straight",
      dashArray: [8, 0, 0, 0, 8],
    },
    title: { text: "Percent (%)", align: "left" },
    markers: { size: 0, hover: { sizeOffset: 6 } },
    xaxis: {
      // text: "Date",
      categories: [
        "Date 0",
        "Date 5",
        "Date 10",
        "Date 15",
        "Date 20",
        "Date 25",
        "Date 30",
        "Date 31",
        // "01 Jan",
        // "02 Jan",
        // "03 Jan",
        // "04 Jan",
        // "05 Jan",
        // "06 Jan",
        // "07 Jan",
        // "08 Jan",
        // "09 Jan",
        // "10 Jan",
        // "11 Jan",
        // "12 Jan",
      ],
    },

    grid: { borderColor: "#f1f1f1" },
  });



  useEffect(() => {
    renderGraph();
  }, [
    props.shipperList,
    props.data,
    props.date,
    props.minMax,
    props.summaryReportPid,
  ]);
  const renderGraph = () => {
    let minMaxList = props.minMax.sort(function (a, b) {
      return b.startDate - a.startDate;
    });
    let min = -5;
    let max = 5;
    let minList = [];
    let maxList = [];

    let dateList = [moment(props.date).locale("en").format("D MMM YYYY")];

    for (let index = 0; index < 29; index++) {
      // maxList.push(min);
      // minList.push(max);
      dateList.unshift(
        moment(props.date)
          .add("days", -(index + 1))
          .locale("en")
          .format("D MMM YYYY")
      );
      // console.log(props.date)
    }
    // console.log(dateList)
    // console.log(dateList)
    let tempGraphData = [];
    dateList.map(date => {
      let minMaxObj = minMaxList.find(row => {
        if (row.endDate != null) {
          return (
            row.startDate <= moment(date).toDate() &&
            moment(date).toDate() <= row.endDate
          );
        } else {
          return row.startDate <= moment(date).toDate();
        }
      });
      if (minMaxObj) {
        maxList.push(minMaxObj.min);
        minList.push(minMaxObj.max);
      } else {
        maxList.push(null);
        minList.push(null);
      }
    });
    // console.log(props.data)
    tempGraphData = [
      ...props.shipperList.map(row => {
        let data = [];

        dateList.map(item => {
          let tempData = props.data.find(obj => {
            if (item == moment(props.date).locale("en").format("D MMM YYYY")) {
              // console.log(obj.BALANCECOLUMN_PID == row.PID,moment(obj.REPORT_DATE).locale("en").format("D MMM YYYY") ==
              // item , props.summaryReportPid ,obj.SUMMARYREPORT_PID);

              return (
                obj.BALANCECOLUMN_PID == row.PID &&
                moment(obj.REPORT_DATE).locale("en").format("D MMM YYYY") ==
                item &&
                props.summaryReportPid == obj.SUMMARYREPORT_PID
              );
            }

            return (
              obj.BALANCECOLUMN_PID == row.PID &&
              moment(obj.REPORT_DATE).locale("en").format("D MMM YYYY") == item
            );
          });

//  console.log(tempData)

          if (tempData == undefined) {
            data.push(null);
          } else {
            data.push(tempData?.BALANCING_BALANCE);
          }
        });

        return {
          name: row.SHIPPER_NAME,
          data: data,
        };
      }),
    ];
    // console.log(tempGraphData)
    // console.log(tempGraphData)
    setSeries([
      {
        name: "MAX",
        data: maxList,
      },
      ...tempGraphData,
      {
        name: "MIN",
        data: minList,
      },
    ]);

    let color = [];
    let width = 3;
    let widthList = [width, width];
    let dashArray = [];

    tempGraphData.map((obj, index) => {
      color.push(props.shipperList[index].garphColor);
      widthList.push(width);
      dashArray.push(0);
    });
    dashArray.unshift(8);
    dashArray.push(8);

    // console.log(tempGraphData)

    setOptions({
      chart: { zoom: { enabled: !1 }, toolbar: { show: !1 } },
      colors: ["#FE5555", ...color, "#FE5555"],
      dataLabels: { enabled: !1 },
      stroke: {
        width: widthList,
        curve: "straight",
        dashArray: dashArray,
      },
      title: { text: "Percent (%)", align: "left" },
      markers: { size: 0, hover: { sizeOffset: 6 } },
      xaxis: {
        categories: dateList.map(row => moment(row).locale("en").format("D MMM")),
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            var val = Math.abs(value);
            if (val >= 1000) {
              if (value < 0) {
                val = val * -1;
              }
              val = numberFormat(val / 1000, 2) + " K";
            } else {
              if (value < 0) {
                val = val * -1;
              }
              val = numberFormat(val, 0);
            }

            return val;
          },
        },
      },
      tooltip: {
        // y: [
        //   {
        //     title: {
        //       formatter: function (e) {
        //         return e + " (mins)";
        //       },
        //     },
        //   },
        //   {
        //     title: {
        //       formatter: function (e) {
        //         return e + " per session";
        //       },
        //     },
        //   },
        //   {
        //     title: {
        //       formatter: function (e) {
        //         return e;
        //       },
        //     },
        //   },
        // ],
      },
      grid: { borderColor: "#f1f1f1" },
    });
  };
  return (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height="400"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

LineGraphTotal.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  shipperList: PropTypes.any,
  date: PropTypes.any,
  minMax: PropTypes.any,
  summaryReportPid: PropTypes.any,
};
export default LineGraphTotal;
